import { useEffect, useState } from "react";

import { SurveyViewFormValues } from "@/features/survey-views/form/types";
import { useGetSurveyViewPreviewMutation } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import { SurveyViewColorScheme } from "@/redux/survey-views/types";

const Preview = ({
  surveyViewData,
}: {
  surveyViewData: SurveyViewFormValues;
}) => {
  const [getPreview, previewResponse] = useGetSurveyViewPreviewMutation();
  const [isIframeLoading, setIsIframeLoading] = useState(false);

  useEffect(() => {
    if (surveyViewData) {
      const data = {
        ...surveyViewData,
        config: {
          ...surveyViewData.config,
          colorScheme: surveyViewData.config.grayScale
            ? SurveyViewColorScheme.GRAY_SCALE
            : SurveyViewColorScheme.DEFAULT,
        },
        answers: surveyViewData.answers.map((answer) => ({
          ...answer,
          attachedBlocks: answer.attachedBlocks.map((block) => block.id),
        })),
      };
      getPreview(data);
    }
  }, [surveyViewData]);

  return (
    <div>
      {(previewResponse.isLoading || isIframeLoading) && (
        <div className="preview-loading-container">
          <BaseSpinner />
        </div>
      )}
      {previewResponse.isSuccess && (
        <iframe
          srcDoc={previewResponse.data.htmlData}
          height="100%"
          width="800px"
          title="Survey Data"
          onLoad={() => setIsIframeLoading(false)}
        />
      )}
    </div>
  );
};

export default Preview;
